import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Check if already loaded
    if (window.fbq) {
      return;
    }
    // Create the fbq stub function
    const fbq: any = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    if (!window.fbq) {
      window.fbq = fbq;
    }
    if (!window._fbq) {
      window._fbq = fbq;
    }
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    // Create and inject the script tag
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    // Add error handler
    script.onerror = () => {
      console.warn('Meta Pixel script failed to load');
    };
    // Add load handler
    script.onload = () => {
      // Initialize after script loads
      if (window.fbq) {
        window.fbq('init', '2049986572601631');
        window.fbq('track', 'PageView');
      }
    };
    // Insert script
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    }
  }, []);
  return <noscript data-id="element-111">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=2049986572601631&ev=PageView&noscript=1" alt="" data-id="element-112" />
    </noscript>;
}